/** Shared with Patient Details — same gender / name formatting for demographics banner. */

export const getGenderText = (gender) => {
  if (gender === 1 || gender === '1' || String(gender).toLowerCase() === 'male') {
    return 'Male';
  }
  if (
    gender === 0 ||
    gender === '0' ||
    gender === 2 ||
    gender === '2' ||
    String(gender).toLowerCase() === 'female'
  ) {
    return 'Female';
  }
  if (gender === 3 || gender === '3' || String(gender).toLowerCase() === 'other') {
    return 'Other';
  }
  return 'N/A';
};

export const formatNameLastFirst = (fullName) => {
  const raw = String(fullName || '').trim();
  if (!raw) return '-';
  if (raw.includes(',')) return raw;
  const parts = raw.split(/\s+/).filter(Boolean);
  if (parts.length === 1) return parts[0];
  const first = parts.shift();
  const last = parts.join(' ');
  return `${last}, ${first}`;
};

export const buildPatientFullName = (patient) => {
  if (!patient) return 'Loading...';
  const fromParts = `${patient.last_name || ''}, ${patient.first_name || ''}`.trim();
  if (fromParts && fromParts !== ',') return fromParts;
  return patient.name || 'Patient';
};

/** Merge fast-measurement payload with fields the demographics banner expects. */
export const enrichPatientForDemographicsBanner = (patientData) => {
  const patient = patientData?.patient;
  if (!patient) return null;
  const caregivers = patientData?.caregivers;
  const firstCaregiver = Array.isArray(caregivers) && caregivers.length > 0 ? caregivers[0] : null;
  const caregiverLabel = firstCaregiver
    ? formatNameLastFirst(
        firstCaregiver.full_name || `${firstCaregiver.last_name || ''} ${firstCaregiver.first_name || ''}`
      )
    : patient.caregiver_name;

  return {
    ...patient,
    practice_name: patient.practice_name || patientData?.practice?.practice_name || null,
    provider_name: patient.provider_name || patientData?.provider_name || null,
    caregiver_name: caregiverLabel || patient.caregiver_name || null,
    ccm_consent_date:
      patient.ccm_consent_date ||
      patientData?.ccm_enrollment_summary?.consent_date ||
      patientData?.ccmEnrollmentSummary?.consent_date ||
      null,
  };
};
